<template>
  <div class="filter-item">
    <div class="columns is-vcentered">
      <div class="column picto-column" :class="{'border-left' : index>0}" >
        <b-button rounded class="filter-button is-large"  @click="openFilterModal()">
          <i class="fa fa-sliders-h"></i>
        </b-button>
      </div>
      <div class="column filter-label">
        <strong>{{filter.title}}</strong><br>
        {{filterValue}}
      </div>
    </div>
  </div>
</template>

<script>
import FilterModal from "@/components/ResearchBlock/machines/FilterModal";

export default {
  name: "FilterItem",
  props : {
    filters: {
      type:Array,
      require:true,
    },
    filter: {
      type:Object,
      require:true
    },
    index : {
      type:Number,
      require:true
    }
  },
  data() {
    return {
      isModalActive: false,
    }
  },

  computed: {
    filterValue () {
      if(this.filter.type==='slider') {
        return this.$t("from")+' '+this.filter.minValue+' '+this.$t('to')+' '+this.filter.maxValue+' '+this.filter.unit
      } else {
        return this.filter.options.find((x)=> {
          return this.filter.value===x.code
        }).label
      }
    }
  },
  methods: {
    openFilterModal(){
      this.$buefy.modal.open({
        parent: this,
        component: FilterModal,
        hasModalCard: true,
        trapFocus: true,
        props:{'filter':this.filter,'index':this.index,'filters':this.filters},
      })
    },
  }
}
</script>

<style lang="scss" >
.filter-item {
  display:inline-block;
  text-align:left;
  .filter-button {
    background-color: $white;
    border-color: $white;
    color: $brand-red;
    font-size: 17px;
    border-radius: 100%;


  }
  .picto-column {
    flex: 0 0 50px; padding:0 0.75em
  }



  .filter-label {
    strong{
      color: $white;
      font-size:110%;
      margin-bottom:5px;
      display:inline-block;
    };
    color: $white;
  }


}
.modal .animation-content {z-index:1}
</style>